import moment from 'moment';
import { Injectable } from '@angular/core';
import { DateSerializer } from '@secca/shared/models/date-serializer';
import { Currency, DineroObject } from 'dinero.js';

export class ICCSplitInvoiceItem {
  id: number;
  caseId: number;
  serviceOrderId: string;
  serviceItemCode: string;
  serviceItemName: string;
  splitMoney: DineroObject;
  splitOriginalInvoiceMoney: DineroObject;
  documentId: string;
  documentName: string;
  modifiedBy: string;
  modifiedOn: moment.Moment;
  deletedBy: string;
  deletedOn: moment.Moment;
  revision: number;
  exchangeRate: number;
  currency: Currency;
  splitMoneyCaseCurrency: DineroObject;


  public constructor(init?: Partial<ICCSplitInvoiceItem>) {
    Object.assign(this, init);
  }

  isValid(): boolean{
    return this.caseId !== null &&
      this.serviceOrderId !== null &&
      this.serviceItemCode !== null &&
      this.serviceItemName !== null &&
      this.splitMoney !== null &&
      this.documentId != null && this.documentId.trim() !== '' &&
      this.documentName != null && this.documentName.trim() !== '';
  }
}

@Injectable({
  providedIn: 'root'
})
export class ICCSplitInvoiceItemAdapter {
  adapt(item: any, exchangeRate: number, supplierInvoiceCurrency: Currency): ICCSplitInvoiceItem {
    return new ICCSplitInvoiceItem({
      id: item.id,
      caseId: item.caseId,
      serviceOrderId: item.serviceOrderId,
      serviceItemCode: item.serviceItemCode,
      serviceItemName: item.serviceItemName,
      splitMoney: item.splitMoney,
      splitOriginalInvoiceMoney: {amount: item.splitMoney.amount * exchangeRate, currency: supplierInvoiceCurrency, precision: 2},
      documentId: item.documentId,
      documentName: item.documentName,
      modifiedBy: item.modifiedBy,
      modifiedOn: item.modifiedOn ? DateSerializer.deserialize(item.modifiedOn) : null,
      deletedBy: item.deletedBy,
      deletedOn: item.deletedOn ? DateSerializer.deserialize(item.deletedOn) : null,
      revision: item.revision
    });
  }
  adaptDirect(item: any): ICCSplitInvoiceItem {
    return new ICCSplitInvoiceItem({
      id: item.id,
      caseId: item.caseId,
      serviceOrderId: item.serviceOrderId,
      serviceItemCode: item.serviceItemCode,
      serviceItemName: item.serviceItemName,
      splitMoney: item.splitMoney,
      splitOriginalInvoiceMoney: {amount: item.splitMoney.amount * item.exchangeRate, currency: item.supplierInvoiceCurrency, precision: 2},
      documentId: item.documentId,
      documentName: item.documentName,
      modifiedBy: item.modifiedBy,
      modifiedOn: item.modifiedOn ? DateSerializer.deserialize(item.modifiedOn) : null,
      deletedBy: item.deletedBy,
      deletedOn: item.deletedOn ? DateSerializer.deserialize(item.deletedOn) : null,
      revision: item.revision,
      splitMoneyCaseCurrency: item.splitMoneyCaseCurrency,
      exchangeRate: item.exchangeRate
    });
  }
}
